export const urls = {
  backend: process.env.REACT_APP_BACKEND_API_URL || 'http://localhost:8080/api',
  aiService: process.env.REACT_APP_SHOVEL_AI_URL || 'http://localhost:8000/api'
};

/** Display label for TopBar and student-app subdomain helpers (LOCAL, STAGE, PRODUCTION, …). */
export const environment = process.env.REACT_APP_ENVIRONMENT ?? 'LOCAL';

export const isDev = process.env.NODE_ENV === 'development';

export const useReactotron = isDev;
